import { render, staticRenderFns } from "./SettingsSlideshow.vue?vue&type=template&id=326bbfe2&scoped=true"
import script from "./SettingsSlideshow.vue?vue&type=script&lang=js"
export * from "./SettingsSlideshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326bbfe2",
  null
  
)

export default component.exports